// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const omastar: PokeData = {
  "id": 139,
  "name": "omastar",
  "height": 10,
  "weight": 350,
  "base_experience": 173,
  "types": [
    PokeType.ROCK,
    PokeType.WATER
  ],
  "api_moves": [
    "bind",
    "sand-attack",
    "horn-attack",
    "leer",
    "bite",
    "supersonic",
    "water-gun",
    "hydro-pump",
    "surf",
    "rock-throw",
    "withdraw",
    "bide",
    "spike-cannon",
    "constrict",
    "rock-slide",
    "protect",
    "rollout",
    "crunch",
    "ancient-power",
    "tickle",
    "mud-shot",
    "rock-blast",
    "brine",
    "shell-smash"
  ],
  "moves": [
    "leer",
    "bite",
    "supersonic",
    "hydro-pump",
    "rock-throw",
    "rock-slide",
    "protect",
    "crunch",
    "ancient-power",
    "mud-shot",
    "rock-blast",
    "brine",
    "rock-smash"
  ],
  "evolution_chain": {
    "id": 69,
    "item": null,
    "species": [
      {
        "name": "omanyte",
        "order": 169,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "omastar",
        "order": 170,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": 138,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 132,
    "speed": 87,
    "ability_power": 181
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
